import React from 'react';
import { GluteHero } from '../components/glute/GluteHero';
import { GluteProblem } from '../components/glute/GluteProblem';
import { GluteMechanism } from '../components/glute/GluteMechanism';
import { GlutePreview } from '../components/glute/GlutePreview';
import { GluteIncludes } from '../components/glute/GluteIncludes';
import { GluteAudience } from '../components/glute/GluteAudience';
import { GluteMethod } from '../components/glute/GluteMethod';
import { GluteTestimonials } from '../components/glute/GluteTestimonials';
import { GluteFaq } from '../components/glute/GluteFaq';
import { GluteOffer } from '../components/glute/GluteOffer';
import { GluteStickyCta } from '../components/glute/GluteStickyCta';
import { Footer } from '../components/Footer';
export function GluteLab() {
  return <div className="w-full bg-coal font-sans" data-id="element-212" data-mp="1s75p1pyx3ucs">
      <GluteHero data-id="element-213" data-mp="1s5unlwsy2you" />
      <main data-id="element-214" data-mp="1s5b2y8bwtw74">
        <GluteProblem data-id="element-215" data-mp="1o62ad6slw4d5" />
        <GluteMechanism data-id="element-216" data-mp="1o6vm6m6f9k25" />
        <GlutePreview data-id="element-217" data-mp="1o5amyj95xcxy" />
        <GluteIncludes data-id="element-218" data-mp="1o3zliq36wha0" />
        <GluteMethod data-id="element-219" data-mp="2j991fc2jizet" />
        <GluteTestimonials data-id="element-220" data-mp="2j9r52trj8fwr" />
        <GluteAudience data-id="element-221" data-mp="2j8g1ov201a66" />
        <GluteFaq data-id="element-222" data-mp="2j74zv0s46chp" />
        <GluteOffer data-id="element-223" data-mp="2o7spbi0p2l9t" />
      </main>
      <Footer data-id="element-224" data-mp="2o70ui9ex8rkl" />
      <div className="h-20 w-full bg-coal-deep" aria-hidden="true" data-id="element-225" data-mp="2o6hkdevij7h4" />
      <GluteStickyCta data-id="element-226" data-mp="2syiscolnec1c" />
    </div>;
}